import { render, staticRenderFns } from "./widgetTrfIpsAdTrafficTrend.vue?vue&type=template&id=5735fdee&scoped=true&"
import script from "./widgetTrfIpsAdTrafficTrend.vue?vue&type=script&lang=js&"
export * from "./widgetTrfIpsAdTrafficTrend.vue?vue&type=script&lang=js&"
import style0 from "./widgetTrfIpsAdTrafficTrend.vue?vue&type=style&index=0&id=5735fdee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5735fdee",
  null
  
)

export default component.exports